"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatusLabel = exports.StyledStatusLabel = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledStatusLabel = styled_components_1.default.div `
  display: inline-block;
  padding: 5px 10px;
  background: #efefef;
  border-radius: 6px;
  text-transform: uppercase;
  text-overflow: ellipsis;
  font-weight: 500;
  font-size: 12px;
  color: #000;
  transition: background 0.25s cubic-bezier(0.075, 0.82, 0.165, 1),
    color 0.25s cubic-bezier(0.075, 0.82, 0.165, 1);
  overflow: hidden;
  max-width: 100%;
  &.small {
    border-radius: 4px;
    padding: 2px 5px;
  }
  &.approved,
  &.published,
  &.completed {
    background: #61cdbb;
  }
  &.warn,
  &.in-review,
  &.in-progress {
    background: rgb(241, 225, 91);
  }
  &.draft {
    background: rgb(33, 150, 243);
    color: #fff;
  }
  &.to-do,
  &.incomplete,
  &.error {
    background: #f47560;
    color: #fff;
  }
`;
const StatusLabel = props => {
    const { status, className = '' } = props;
    const text = status || 'Unknown Status';
    return (react_1.default.createElement(exports.StyledStatusLabel, { title: text, className: `status-label ${className}` }, text));
};
exports.StatusLabel = StatusLabel;
exports.default = exports.StatusLabel;
//# sourceMappingURL=StatusLabel.js.map